<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>资源管理
        <span class="tipText">各位老师，上传资源后请耐心等待，若提示“资源加工失败”，再重新上传，期间请勿重复上传。</span>
      </p>
    </div>
    <div class="panel-content">
      <form
        id="searchSection"
        onSubmit="return false;"
      >
        <input
          type="text"
          placeholder="资源名称"
          class="s-input separate"
          v-model="queryInfo.title"
        >
        <input
          type="button"
          class="s-btn"
          value="搜索"
          @click="pageCallback(1)"
        >
        <div
          class="add-btn"
          id="addResource"
          @click="toUploadWindow"
        >上传资源</div>
      </form>
      <div class="toggle_category">
        <ul class="toggle_type">
          <li
            :class="active===''?'active':''"
            @click="searchResource('')"
          >全部</li>
          <li
            v-for="(item,index) in categoryList"
            :key="index"
            :value="item.id"
            :class="active===index?'active':''"
            @mouseover="delIndex=index"
            @mouseleave="delIndex=''"
            @click="searchResource(index,item.id)"
          ><span>{{item.title}}</span><span
              class="del_category"
              :style="delIndex===index?'display:inline':'display:none'"
              @click="delResourceCategory(index,item)"
            >x</span></li>

        </ul>
        <span
          class="add-subject-btn"
          @click="showSubjectWindow"
        >添加</span>
      </div>
      <ul
        id="resourceList"
        class="resource-list"
        v-if="tableData.length"
      >
        <li
          v-for="(item, index) in tableData"
          :key="index"
        >
          <div class="line-wrap">
            <div
              class="photo lookWare"
              index="0"
              @click="showViewWindow(item)"
            >
              <img
                src="/images/default.jpg"
                :onerror="$store.state.defaultImg"
              >
            </div>
            <div class="actionBtn">
              <a
                href="javascript:;"
                @click="editResource(item)"
                class="edit"
              >编辑</a>
              <a
                href="javascript:;"
                @click="delResource(item)"
                class="delete"
              >删除</a>
            </div>
            <div class="info">
              <div
                class="title"
                title="dog 2"
              ><span>{{item.title}}</span><span class="resourceCategory">{{item.resourceCategory.title}}</span></div>
              <div class="rl">
                <span class="res-type">{{$store.state.dict_resource_type[item.resourceType]}}</span>
                <span class="size">{{ (item.size / 1024).toFixed(2) }}
                  KB</span>
                <span>引用：0次</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div
        class="noitems"
        v-else
      >没有数据</div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>

    <div
      class="form_overlay"
      id="ware_overlay"
      :style="classShowAddWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">编辑资源</div>
        <a
          href="javascript:void(0)"
          class="overlay-close"
          @click="hideAddWindow"
        ><i class="iconfont"></i>

        </a>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require">*</i>资源名称</span>
              <input
                type="text"
                autocomplete="off"
                v-model="formInfo.title"
                maxlength="25"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>资源分类:</span>
              <select v-model="formInfo.resourceCategory_id">
                <option value="">请选择</option>
                <option
                  v-for="item in categoryList"
                  :key="item.id"
                  :value="item.id"
                >{{item.title}}</option>
              </select>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>资源类型:</span>
              <input
                type="hidden"
                v-model="formInfo.id"
              >
              <select v-model="formInfo.resourceType">
                <option value="">请选择资源类型</option>
                <option :value="1">文本类</option>
                <option :value="2">微课类</option>
                <option :value="3">图形/图像类</option>
                <option :value="4">音频类</option>
                <option :value="5">视频类</option>
                <option :value="6">动画类</option>
                <option :value="7">虚拟仿真类</option>
                <option :value="8">PPT演示文稿</option>
                <option :value="9">网页课件</option>
                <option :value="10">富媒体</option>
                <option :value="11">其他</option>
              </select>
            </div>

            <div class="item">
              <span class="label"><i class="require">*</i>是否原创:</span>
              <input
                type="hidden"
                v-model="formInfo.id"
              >
              <select v-model="formInfo.isOri">
                <option :value="1">是</option>
                <option :value="0">否</option>
              </select>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>作者</span>
              <input
                type="text"
                autocomplete="off"
                v-model="formInfo.author"
                maxlength="25"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>版权单位</span>
              <input
                type="text"
                autocomplete="off"
                v-model="formInfo.org"
                maxlength="25"
              >
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="ware_close"
            @click="hideAddWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="ware_submit"
            @click="saveResource"
          >提交</a>
        </div>
      </div>
    </div>

    <div
      class="form_overlay"
      id="look_overlay"
      :style="classShowViewWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">查看资源</div>
        <a
          href="javascript:void(0)"
          class="overlay-close"
          @click="hideViewWindow"
        ><i class="iconfont"></i>

        </a>
        <div class="form_content">
          <div
            class="look-wrap"
            id="lookWrap"
          >
            <div
              class="video-wrap"
              v-if="viewInfo.path.split('.')[viewInfo.path.split('.').length - 1]=='mp4'"
            >
              <video
                style="background:#000;max-height:460px;max-width:100%;margin: 0 auto;display: block;"
                :src="$store.state.rootUrl+viewInfo.path.substr(1,viewInfo.path.length)"
                controls="controls"
              ></video>
            </div>
            <img
              v-if="viewInfo.path.split('.')[viewInfo.path.split('.').length - 1]=='png' || viewInfo.path.split('.')[viewInfo.path.split('.').length - 1]=='jpg'"
              :src="$store.state.rootUrl+viewInfo.path.substr(1,viewInfo.path.length)"
            />
          </div>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="look_close"
            @click="hideViewWindow"
          >取消</a>
        </div>
      </div>
    </div>

    <div
      class="form_overlay"
      id="subject_form_overlay"
      :style="classSubjectWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">自建分类</div>
        <div class="form_content">
          <form id="subjectForm">
            <div class="item">
              <span class="label"><i class="require">*</i>分类名称</span>
              <input
                type="text"
                value=""
                v-model="categoryInfo.title"
              >
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            class="button close"
            href="javascript:void(0)"
            @click="hideSubjectWindow"
          >取消</a>
          <a
            class="button"
            id="subject_form_submit"
            @click="saveSubject"
          >提交</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'ExperimentResource',
  components: {
    Pagination
  },
  data() {
    return {
      delIndex: '',
      active: '',
      classShowAddWindow: {},
      classShowUploadWindow: {},
      classShowViewWindow: {},
      classSubjectWindow: {},
      tableData: [],
      tableDataCount: 0,
      categoryList: [],
      queryInfo: {
        page: 1,
        size: 10,
        title: '',
        resourceCategory_id: ''
      },
      categoryInfo: {
        title: ''
      },
      formInfo: {
        id: 0,
        title: '',
        resourceType: '',
        isOri: 1,
        author: '',
        resourceCategory_id: '',
        createUser_id: this.$store.state.userInfo.profile_id,
        path: '',
        size: '',
        org: ''
      },
      formResourceSubjectList: [],
      viewInfo: {
        path: ''
      }
    }
  },
  methods: {
    // 学院分页
    pageCallback(data) {
      this.queryInfo.page = data
      this.queryResource()
    },
    showSubjectWindow() {
      this.classSubjectWindow = {
        visibility: 'visible'
      }
    },
    hideSubjectWindow() {
      this.classSubjectWindow = {}
    },
    // 打开专业添加/编辑弹窗
    showAddWindow() {
      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },
    // 关闭专业添加/编辑弹窗
    hideAddWindow() {
      this.classShowAddWindow = {}
    },

    showViewWindow(item) {
      this.viewInfo.path = item.path
      this.classShowViewWindow = {
        visibility: 'visible'
      }
    },
    hideViewWindow() {
      this.classShowViewWindow = {}
    },
    toUploadWindow() {
      this.$router.push('/admin/resource_manage/upload')
    },
    // 添加资源分类
    async saveSubject() {
      await this.$http.post('/resource_category/', this.categoryInfo).then((data) => {
        if (data.id) {
          this.$parent.showMsg('添加成功！')
          this.hideSubjectWindow()
          this.getResourceCategory()
        } else {
          this.$parent.showMsg('添加失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('添加失败！')
      })
    },
    searchResource(index, id) {
      this.active = index
      this.queryInfo.resourceCategory_id = id
      this.queryResource()
    },
    async queryResource() {
      await this.$http.get('/resource/', { params: this.queryInfo }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('查询资源信息失败！')
      })
    },
    // 获取所有资源分类
    async getResourceCategory() {
      await this.$http.get('/resource_category/', {
        page: 1,
        size: 1000
      }).then((data) => {
        this.categoryList = data.results
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('添加失败！')
      })
    },
    async saveResource() {
      const url = '/resource/' + this.formInfo.id + '/'
      await this.$http.put(url, this.formInfo).then((data) => {
        if (data.id) {
          this.hideAddWindow()
          this.queryResource()
        } else {
          this.$parent.showMsg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('修改失败！')
      })
    },
    editResource(item) {
      this.formInfo = {
        id: item.id,
        title: item.title,
        resourceType: item.resourceType,
        isOri: item.isOri,
        author: item.author,
        resourceCategory_id: item.resourceCategory_id,
        createUser_id: this.$store.state.userInfo.profile_id,
        path: item.path,
        size: item.size,
        org: item.org
      }
      this.showAddWindow()
    },
    async delResource(item) {
      const url = '/resource/' + item.id + '/'
      await this.$parent.showConfirm('确认删除此条数据吗?', () => {
        this.$http.put(url, {
          path: item.path,
          title: item.title,
          isdel: 1
        }).then((data) => {
          if (data.id) {
            this.$parent.showMsg('删除成功！')
            this.queryResource()
          } else {
            this.$parent.showMsg('删除失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('删除失败！')
        })
      })
    },
    async delResourceCategory(index, item) {
      this.active = index
      const url = '/resource_category/' + item.id + '/'
      await this.$parent.showConfirm('确认删除此条数据吗?', () => {
        this.$http.put(url, {
          title: item.title,
          isdel: 1
        }).then((data) => {
          if (data.id) {
            this.$parent.showMsg('删除成功！')
            this.getResourceCategory()
          } else {
            this.$parent.showMsg('删除失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('删除失败！')
        })
      })
    }

  },
  // 计算属性
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    }

  },
  mounted() {
    this.queryResource()
    this.getResourceCategory()
    window.scroll(0, 0)
  }
}
</script>

<style scoped src="../../../assets/css/chunkUpload.css"></style>
<style scoped src="../../../assets/css/resources.css"></style>
<style lang="less" scoped>
.toggle_type {
  margin: 20px 0;
  li {
    display: inline-block;
    font-size: 16px;
    color: #999;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
  }
  li.active {
    color: #2aa9a9;
    border-bottom: 2px solid #2aa9a9;
  }
}
.file-upload {
  width: 50%;
  height: auto;
  transform: translate(-50%, -50%);
  margin-left: 0;
  margin-top: 0;
  .file-upload-type {
    p {
      line-height: 2;
      font-size: 16px;
      color: #999;
      &:last-child {
        color: red;
      }
    }
  }
}
.toggle_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding: 10px 0;
  margin: 0 0 40px;
  > span {
    color: #09c6cd;
  }
}
.toggle {
  span {
    border: 1px solid #ccc;
    border-bottom: none;
    padding: 10px;
    background: #f1f1f1;
    &:first-child {
      border-right: none;
    }
  }
  .active {
    background: #09c6cd;
    color: #fff;
  }
}
.file_uploadBtn {
  background: #fe6161;
  border-radius: 0;
}
.toggle_category {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.add-subject-btn {
  color: #666;
  border: 1px solid #ddd;
  background: #f5f5f5;
  padding: 0 10px;
  border-radius: 3px;
  cursor: pointer;
  float: left;
  height: 23px;
  line-height: 23px;
  margin-left: 10px;
  margin-top: 3px;
}
.resourceCategory {
  display: inline-block;
  margin-left: 10px;
  padding: 5px;
  background: #009999;
  color: #fff;
}
.del_category {
  color: red;
  margin-left: 5px;
  display: none;
}
</style>
